/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { signInActions } from '../sign-in/slice';

/**
 * Define the the users feature initial state
 */
export const initialState = {
  loading: false,
  createdModel: {},
  allModels: [],
  llmDefaultModels: {},
  modelUsage: {},
  llmLogs: { results: [], page: 1, limit: 100, totalPages: 0, totalResults: 0 },
  chartLogs: [],
  usageLoading: false,
  logsLoading: false,
  chartLogsLoading: false,
};
/**
 * Here mentioned all the users feature related actions
 */
export const llmSlice = createSlice({
  name: 'feature/llm',
  initialState,
  reducers: {
    createModel(state) {
      state.loading = true;
    },
    createModelSucceeded(state, action) {
      state.loading = false;
      state.allModels = {
        ...state.allModels,
        results: [...(state.allModels?.results ?? []), action?.payload],
      };
      state.createdModel = action.payload;
    },
    createModelFailed(state) {
      state.loading = false;
    },
    resetModelCreation(state) {
      state.loading = false;
      state.createdModel = {};
    },
    getAllModels(state) {
      state.loading = true;
    },
    getAllModelsSucceeded(state, action) {
      state.loading = false;
      state.allModels = action.payload;
    },
    getAllModelsFailed(state) {
      state.loading = false;
    },
       createDefaultModelsInformation(state) {
      state.loading = true;
    },
    createDefaultModelsInformationSucceeded(state, action) {
      state.loading = false;
      state.llmDefaultModels = action?.payload;
    },
    createDefaultModelsInformationFailed(state) {
      state.loading = false;
    },
    updateDefaultModelsInformation(state) {
      state.loading = true;
    },
    updateDefaultModelsInformationSucceeded(state, action) {
      state.loading = false;
      state.llmDefaultModels = action?.payload;
    },
    updateDefaultModelsInformationFailed(state) {
      state.loading = false;
    },
     getDefaultModelsInformation(state) {
      state.loading = true;
    },
    getDefaultModelsInformationSucceeded(state, action) {
      state.loading = false;
      state.llmDefaultModels =  action?.payload?.results?.[0]?? {}
    },
    getDefaultModelsInformationFailed(state) {
      state.loading = false;
    },
    getModelUsage(state) {
      state.usageLoading = true;
    },
    getModelUsageSucceeded(state, action) {
      state.usageLoading = false;
      state.modelUsage = action.payload;
    },
    getModelUsageFailed(state) {
      state.usageLoading = false;
    },
    getLlmLogs(state) {
      state.logsLoading = true;
    },
    getLlmLogsSucceeded(state, action) {
      state.logsLoading = false;
      state.llmLogs = action.payload;
    },
    getLlmLogsFailed(state) {
      state.logsLoading = false;
    },
    getChartLogs(state) {
      state.chartLogsLoading = true;
    },
    getChartLogsSucceeded(state, action) {
      state.chartLogsLoading = false;
      state.chartLogs = action.payload;
    },
    getChartLogsFailed(state) {
      state.chartLogsLoading = false;
      state.chartLogs = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: llmActions } = llmSlice;
